/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { MqttService } from "../../../widgets/mqtt-v2-service-react";
import { DEFAULT_APP_CONFIG } from "../../../config/default.config";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const eb = EventBusModule?.getInstance();
let _eb = eb.getEventBus();
let allTopics: any = null;

export interface IMqttConntectMethods extends IPluginMethodMap {
  init(args: any): Promise<any>;
}

export class MqttConntectService implements IAgentPlugin {
  readonly methods: IMqttConntectMethods;
  private client?: any;
  private eventBus: any;
  constructor() {
    this.methods = {
      init: this.init.bind(this),
    };
  }

  async init(args: any) {
    allTopics = args;
    try {
      log.info(`in init() args`, args);
      this.client = await MqttService.getInstance({
        brokerURL: DEFAULT_APP_CONFIG?.mqttService?.MQTT_BROKER_URL,
        username: DEFAULT_APP_CONFIG?.mqttService?.MQTT_USERNAME,
        password: DEFAULT_APP_CONFIG?.mqttService?.MQTT_PASSWORD,
      });
      this.eventBus = this.client.getEventBus();
      this.eventBus.on("connect", () => {
        console.log("connected -----------------");
        this.client.subscribeTopics(args);
      });
      this.eventBus.on("connect", this.eventHandler.bind(this, "connect"));
      this.eventBus.on("closed", this.eventHandler.bind(this, "closed"));
      this.eventBus.on("error", this.eventHandler.bind(this, "error"));
      this.eventBus.on("message", this.eventHandler.bind(this, "message"));
    } catch (e) {}
  }

  async eventHandler(event: string, msg?: any) {
    log.success(`[mqtt] event ${event}`, msg);
    if (event === "message") {
      let topic = msg?.topic;
      let data = msg?.message;
      log.blue(`mqtt on any change in TV queue 0`, topic, data);
      let formatQueue = this.formatDistributionQueueData(data?.jobs?.data);
      formatQueue && _eb.emit("distributionQueue", this, formatQueue);
    }
  }
  // "isPayerCalledOut": true,
  //       "isDistributorCounterCalledOut": false,
  //       "payerCounterNo": 2,
  //       "distributorCounterNo": null,
  //       "token": "G123",
  //       "fullName": "Mosai Bipin  Babu Rao Sarode"

  private formatDistributionQueueData = (data: any) => {
    const distCenterData = storageService.get("distCenterData", "local");
    let vipList: any[] = [];
    let nonVipList: any[] = [];
    let activeUser: any[] = [];
    let isCalledOut: boolean = false;

    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((item: any) => {
        if (
          item?.data?.lockedByDistCounter === distCenterData?.paymentCounter &&
          item?.data?.isCalledOutByDistCounter === true
        ) {
          isCalledOut = item?.data?.isCalledOutByDistCounter;
          let _userInfo =
            item?.data?.boxData &&
            Array.isArray(item?.data?.boxData) &&
            item?.data?.boxData?.length > 0 &&
            item?.data?.boxData[0];
          activeUser.push({
            name: _userInfo?.fullName,
            image: "https://www.w3schools.com/howto/img_avatar.png",
            masqId: _userInfo?.masqID,
            tokenTitle: "Token No",
            token:
              item?.data?.tokenKey && item?.data?.tokenKey.includes("__")
                ? item?.data?.tokenKey.split("__")[1]
                : item?.data?.tokenKey,
            waitingTimeTitle: "Waiting Time",
            waitingTime: this.formatWaitingTime(item?.data?.createdOn),
            listItems: [],
            tokenKey: item?.data?.tokenKey,
          });
          if (item?.data?.isVipToken) {
            vipList.push({
              ...item?.data,
              appCardId: item?.data?.tokenKey,
              appCardImage: "",
              appCardTitle: item?.data?.isGroup
                ? ""
                : this.formatAppCardTitle(item?.data?.boxData),
              appCardDescription: this.formatCardDescription(
                item?.data?.boxData
              ),
              appCardList: this.formatAppCardList(item?.data),
              timeStamp: this.formatWaitingTime(item?.data?.createdOn),
            });
          } else {
            nonVipList.push({
              ...item?.data,
              appCardId: item?.data?.tokenKey,
              appCardImage: "",
              appCardTitle: item?.data?.isGroup
                ? ""
                : this.formatAppCardTitle(item?.data?.boxData),
              appCardDescription: this.formatCardDescription(
                item?.data?.boxData
              ),
              appCardList: this.formatAppCardList(item?.data),
              timeStamp: this.formatWaitingTime(item?.data?.createdOn),
            });
          }
        }
        if (item?.data?.isVipToken && !item?.data?.isCalledOutByDistCounter) {
          vipList.push({
            ...item?.data,
            appCardId: item?.data?.tokenKey,
            appCardImage: "",
            appCardTitle: item?.data?.isGroup
              ? ""
              : this.formatAppCardTitle(item?.data?.boxData),
            appCardDescription: this.formatCardDescription(item?.data?.boxData),
            appCardList: this.formatAppCardList(item?.data),
            timeStamp: this.formatWaitingTime(item?.data?.createdOn),
          });
        } else if (!item?.data?.isCalledOutByDistCounter) {
          nonVipList.push({
            ...item?.data,
            appCardId: item?.data?.tokenKey,
            appCardImage: "",
            appCardTitle: item?.data?.isGroup
              ? ""
              : this.formatAppCardTitle(item?.data?.boxData),
            appCardDescription: this.formatCardDescription(item?.data?.boxData),
            appCardList: this.formatAppCardList(item?.data),
            timeStamp: this.formatWaitingTime(item?.data?.createdOn),
          });
        }
      });

    return {
      vipList: this.sortTokens(vipList),
      nonVipList: this.sortTokens(nonVipList),
      activeUser,
      isCalledOut,
    };
  };

  private sortTokens = (tokens: any) => {
    //sort by time in descending order
    let _tokens = tokens.sort((a: any, b: any) => {
      return b.timeStamp - a.timeStamp;
    });
    log.info(`before sorted :`, _tokens);
    return _tokens;

    // const _tokens = tokens.sort((a: any, b: any) => {
    //   return b.timeStamp - a.timeStamp;
    // });
    // console.log(`sorted tokens`, _tokens);
    // return _tokens;
  };

  private formatAppCardTitle = (data: any) => {
    let title = "";
    title =
      data && Array.isArray(data) && data.length > 0 ? data[0]?.fullName : "";
    return title;
  };

  private formatCardDescription = (data: any) => {
    let description = "";
    description =
      data && Array.isArray(data) && data.length > 0 ? data[0]?.masqID : "";
    return description;
  };

  private formatAppCardList = (data: any) => {
    let list: any[] = [];
    if (data?.tokenKey) {
      list.push({
        name: "Token",
        value: this.formatToken(data?.tokenKey),
      });
    }
    if (data?.createdOn) {
      list.push({
        name: "Waiting Time",
        value: this.formatWaitingTime(data?.createdOn),
      });
    }
    return list;
  };

  private formatToken = (token: string) => {
    let formattedToken = "";
    if (token) {
      formattedToken = token?.split("__")[1];
    }
    return formattedToken;
  };

  private formatWaitingTime = (createdOn: string) => {
    let waitingTime = null;
    if (createdOn) {
      let currentData = moment();
      let arrivalTime = moment(createdOn);
      waitingTime = currentData.diff(arrivalTime, "seconds");

      //moment convert seconds to HH:mm format
      waitingTime = moment.utc(waitingTime * 1000).format("HH:mm");
    }
    return waitingTime;
  };
}
